
import { ModalActions } from "./ModalActions";

interface ModalFooterProps {
  onCancel: () => void;
  onSave: () => void;
}

export const ModalFooter = ({ onCancel, onSave }: ModalFooterProps) => {
  return (
    <div className="space-y-4 text-white">
      <ModalActions onCancel={onCancel} onSave={onSave} />
    </div>
  );
};
